import * as actionType from 'actions';

export const getJobApplicationPdf = (request, key) => ({
    type: actionType.GET_JOB_APPLICATION_PDF,
    payload: request,
    key: key,
});

export const getJobApplicationPdfSuccess = (response) => ({
    type: actionType.GET_JOB_APPLICATION_PDF_SUCCESS,
    payload: response,
}); 